import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import SimpleModal from 'components/SimpleModal';
function Message(_ref) {
  var uniqueUsers = _ref.uniqueUsers,
    data = _ref.data;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var name = data.name,
    type = data.type,
    assetIds = data.assetIds,
    playlistIds = data.playlistIds;
  var contentCount = type === 'playlist' ? playlistIds === null || playlistIds === void 0 ? void 0 : playlistIds.length : assetIds === null || assetIds === void 0 ? void 0 : assetIds.length;
  if (name) {
    return /*#__PURE__*/React.createElement(Trans, {
      t: t,
      i18nKey: "modal_share_with_users_message_users",
      count: uniqueUsers
    }, "This will share", {
      name: name
    }, " with", {
      uniqueUsers: uniqueUsers
    }, " users.");
  }
  if (type === 'playlist') {
    return /*#__PURE__*/React.createElement(Trans, {
      t: t,
      i18nKey: "modal_share_with_users_message_users_playlist",
      count: uniqueUsers,
      contentCount: contentCount
    }, "This will share", {
      contentCount: contentCount
    }, " playlists with", {
      uniqueUsers: uniqueUsers
    }, " users.");
  }
  return /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "modal_share_with_users_message_users_asset",
    count: uniqueUsers,
    contentCount: contentCount
  }, "This will share", {
    contentCount: contentCount
  }, " assets with", {
    uniqueUsers: uniqueUsers
  }, " users.");
}
function ConfirmationModal(_ref2) {
  var uniqueUsers = _ref2.uniqueUsers,
    data = _ref2.data,
    onCancel = _ref2.onCancel,
    onConfirm = _ref2.onConfirm;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: uniqueUsers ? t('modal_share_with_users_title', {
      count: uniqueUsers
    }) : t('modal_share_with_users_title_empty'),
    onClose: onCancel,
    body: uniqueUsers ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Message, {
      uniqueUsers: uniqueUsers,
      data: data
    })), /*#__PURE__*/React.createElement("p", null, t('modal_share_with_users_message_proceed'))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, t('modal_share_with_users_message_no_users')), /*#__PURE__*/React.createElement("p", null, t('modal_share_with_users_message_no_users_info'))),
    buttons: [{
      label: t('actions_cancel'),
      onClick: onCancel
    }, {
      variant: 'primary',
      label: t('modal_share_with_users_cta'),
      onClick: onConfirm,
      isDisabled: !uniqueUsers
    }]
  });
}
export default ConfirmationModal;